/**
 * Apple Sign-In OAuth URL builder for web.
 *
 * Apple uses response_mode=form_post — Apple POSTs the result
 * to our callback URL instead of redirecting with query params.
 *
 * No client-side CSRF state: Apple form_post is cross-site, so SameSite=Lax
 * cookies are dropped, and SameSite=None breaks under Safari/iOS ITP and
 * private browsing. Real protection comes from the bearer id_token, which
 * the backend verifies against Apple's public keys (issuer, audience,
 * expiration, signature) — an attacker cannot forge or replay it.
 */
/**
 * `state` value marking an "add Apple to the signed-in account" round trip
 * (docs/identity/ADR-001). Apple echoes it in the form_post, so the server
 * route knows to hand the Apple tokens to the browser instead of signing in:
 * only the browser holds the account's bearer token.
 */
export const APPLE_LINK_STATE = 'link';

export function getAppleOAuthUrl({ link = false }: { link?: boolean } = {}): string {
  const clientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID;
  if (!clientId) {
    throw new Error('NEXT_PUBLIC_APPLE_CLIENT_ID is not configured');
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: `${window.location.origin}/api/auth/apple/callback`,
    response_type: 'code id_token',
    response_mode: 'form_post',
    scope: 'name email',
    ...(link && { state: APPLE_LINK_STATE }),
  });

  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
}
